/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'overbooking': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 7)" _stroke="#00272E"><path pid="0" d="M17.634 16.839a.466.466 0 01-.452.731H.818a.466.466 0 01-.452-.731L8.634.303c.202-.403.53-.403.732 0l8.268 16.536z"/><path pid="1" d="M9 12.256V6.528"/><path pid="2" d="M8.993 13.892a.201.201 0 00-.198.209c.005.111.096.2.208.2h.004a.201.201 0 00.198-.209.209.209 0 00-.205-.2h-.004"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/overbooking.js